import { Theme } from '@mui/material/styles';

export const getLabelStyles = (theme: Theme) => ({
  color: theme.palette.text.main,
});

export const getPasswordTextStyles = (theme: Theme, isPassword: boolean) => ({
  color: theme.palette.text.primary,
  wordBreak: 'break-all' as const,
  textAlign: 'right' as const,
  fontFamily: isPassword ? 'monospace' : 'inherit',
  fontWeight: 400,
});

export const getIconButtonStyles = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    color: theme.palette.primary.main,
    transform: 'scale(1.1)',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
});

export const getPlatformButtonStyles = (
  theme: Theme,
  isPrimaryColor: boolean,
) => ({
  fontSize: theme.typography.pxToRem(16),
  gap: 2,
  borderColor: isPrimaryColor
    ? theme.palette.primary.main
    : theme.palette.text.main,
  color: isPrimaryColor ? theme.palette.primary.main : theme.palette.text.main,
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: isPrimaryColor
      ? theme.palette.primary.main
      : theme.palette.text.main,
    color: isPrimaryColor
      ? theme.palette.primary.main
      : theme.palette.text.main,
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon > svg, & .MuiButton-endIcon > svg': {
    fill: isPrimaryColor ? theme.palette.primary.main : theme.palette.text.main,
    stroke: isPrimaryColor
      ? theme.palette.primary.main
      : theme.palette.text.main,
  },
});

export const getAnimatedPasswordStyles = (
  theme: Theme,
  isPassword: boolean,
  showPassword?: boolean,
) => ({
  color: theme.palette.text.primary,
  wordBreak: 'break-all' as const,
  textAlign: 'right' as const,
  fontFamily: isPassword ? 'monospace' : 'inherit',
  fontWeight: 400,
  transition: 'all 0.3s ease-in-out',
  opacity: 1,
  transform: 'translateY(0)',
  maxWidth: '100%',
  overflow:
    isPassword && !showPassword ? ('visible' as const) : ('hidden' as const),
  textOverflow:
    isPassword && !showPassword ? ('clip' as const) : ('ellipsis' as const),
  whiteSpace:
    isPassword && !showPassword ? ('normal' as const) : ('nowrap' as const),
  flex: 1,
  minWidth: 0,
  '&.password-changing': {
    opacity: 0,
    transform: 'translateY(-4px)',
  },
});

export const getPasswordContainerStyles = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  minHeight: '20px',
  flex: 1,
  minWidth: 0,
});
